import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Aguarda de forma reativa a inicialização do AuthService.
 * Substitui o antigo `setTimeout(1000)` fixo, que abria uma janela de corrida
 * onde a rota resolvia antes do estado de auth estar pronto (TG-382 / TG-383 #15).
 */
export async function waitForAuthInit(authService: AuthService): Promise<void> {
  if (authService.isInitialized()) {
    return;
  }

  await firstValueFrom(toObservable(authService.isInitialized).pipe(filter(Boolean)));
}
